(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["or-manufacturer-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('or-manufacturer-video')) {
    customElements.define('or-manufacturer-video', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.generation ??= 0;
        this.stage = this.querySelector('.or-video-stage');
        this.button = this.querySelector('.or-video-load');
        if (!this.stage || !this.button) return;
        this.button.hidden = false;
        this.button.addEventListener('click', () => this.loadVideo(), { signal: this.controller.signal });
        if (this.dataset.productId) {
          document.addEventListener('shopify:product:select', event => this.selectVariant(event), { signal: this.controller.signal });
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.generation += 1;
        this.resetVideo();
      }
      loadVideo() {
        if (this.hidden || this.stage.querySelector('iframe')) return;
        const videoId = this.dataset.videoId;
        if (!['mA660Y38Iwg', 'Oc1opFx_i_c'].includes(videoId)) return;
        const player = document.createElement('iframe');
        player.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=0&playsinline=1&rel=0';
        player.title = this.dataset.playerTitle;
        player.allow = 'encrypted-media; picture-in-picture; fullscreen';
        player.allowFullscreen = true;
        player.referrerPolicy = 'strict-origin-when-cross-origin';
        player.tabIndex = 0;
        this.stage.append(player);
        this.button.hidden = true;
        player.focus();
      }
      resetVideo() {
        this.stage?.querySelector('iframe')?.remove();
        if (this.button) this.button.hidden = false;
      }
      async selectVariant(event) {
        if (event.target?.closest?.('product-card, quick-add-dialog')) return;
        const productId = String(event.product?.id ?? '').split('/').pop();
        if (productId !== this.dataset.productId) return;
        const generation = ++this.generation;
        this.hidden = true;
        this.resetVideo();
        try {
          const result = await event.promise;
          if (!this.isConnected || generation !== this.generation) return;
          const variantId = String(result?.detail?.resource?.id ?? result?.variant?.id ?? '').split('/').pop();
          this.hidden = variantId !== this.dataset.variantId;
        } catch {
          if (this.isConnected && generation === this.generation) this.hidden = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["or-market-toolbar"]) return;
  try {
    
  if (!customElements.get('oak-language-switcher')) {
    customElements.define('oak-language-switcher', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const form = this.querySelector('form');
        const select = this.querySelector('[name="language_code"]');
        if (!form || !select) return;
        const preserveLocation = () => {
          const destination = form.querySelector('[name="return_to"]');
          if (destination) destination.value = window.location.pathname + window.location.search + window.location.hash;
        };
        form.addEventListener('submit', preserveLocation, {signal: this.controller.signal});
        select.addEventListener('change', () => {
          preserveLocation();
          form.requestSubmit();
        }, {signal: this.controller.signal});
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
